export default "__VITE_ASSET__CHkcNchK__"